'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _elements = require('../../elements');

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Section = require('./Section');

var _Section2 = _interopRequireDefault(_Section);

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Title = require('./Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageLarge(props) {
  return _react2.default.createElement(_styledComponentsReactiveGrid.Container, props);
}

MessageLarge.Footer = _Footer2.default;
MessageLarge.Header = _Header2.default;
MessageLarge.Icon = _Icon2.default;
MessageLarge.Section = _Section2.default;
MessageLarge.Text = _elements.P;
MessageLarge.Title = _Title2.default;

exports.default = MessageLarge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/MessageLarge/index.js
// module id = 1563
// module chunks = 2